// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1yvuJ","errorLogs":"styles_errorLogs__3eYm1"};